import { useEffect, useState } from "react";
import styles from "./NewDeck.module.sass";

import cn from "classnames";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router";
import { addCatalogItem } from "../../app/catalog/catalog.slice";
import { fetchCreateDeck, fetchEditDeck, fetchUpdateDeck, fetchUpdateDeckAvatar } from "../../app/decks/decks.slice";
import Loader from "../../components/Loader";
import { parseSearchCardTags, parseSearchClassesTags } from "../../utils";
import { AVAILABLE_LANGS } from "../../utils/constants";
import CategoryAndAttibutes from "./CategoryAndAttibutes";
import ImagesAndCTA from "./ImagesAndCTA";
import IncludedCards from "./IncludedCards";
import IncludedClasses from "./IncludedClasses";
import Invitations from "./Invitations";
import NameAndDescription from "./NameAndDescription";
import Preview from "./Preview";
import Price from "./Price";

export const levelOptions = [
  { value: "Newbie", label: "Newbie" },
  { value: "Begginer", label: "Beginner" },
  { value: "Intermediate", label: "Intermediate" },
  { value: "Advanced", label: "Advanced" },
  { value: "Master", label: "Master" },
];

function getCategoryTitles(categories, categoryId, subcategoryId) {
  if (!categories?.length || !categoryId || !subcategoryId) return { categoryTitle: '', subcategoryTitle: '' };
  const cat = categories.find((c) => String(c._id) === String(categoryId));
  const sub = cat?.subCategories?.find((s) => String(s._id) === String(subcategoryId));
  const getTitle = (obj) => obj?.translations?.find((t) => t?.lang === 'en')?.trans || obj?.title || '';
  return {
    categoryTitle: getTitle(cat) || String(categoryId),
    subcategoryTitle: getTitle(sub) || String(subcategoryId),
  };
}

const NewDeck = ({ isNew = false }) => {
  const { user, decks } = useSelector((state) => state);

  const [visiblePreview, setVisiblePreview] = useState(false);
  const [visibleModal, setVisibleModal] = useState(false);

  const [startDate, setStartDate] = useState(new Date());
  const [startTime, setStartTime] = useState(new Date());

  const [fileURL, setFileURL] = useState('')

  const [title, setTitle] = useState("");
  const [available, setAvailable] = useState(true);
  const [level, setLevel] = useState("Newbie");
  const [category, setCategory] = useState('');
  const [subCategory, setSubCategory] = useState('');
  const [description, setDescription] = useState();
  const [descriptionState, setDescriptionState] = useState();
  const [premiumActive, setPremiumActive] = useState(false)
  const [premiumPrice, setPremiumPrice] = useState('')
  const [selectedCards, setSelectedCards] = useState([]);
  const [avatarUrl, setAvatarUrl] = useState('')
  const [file, setFile] = useState('')
  const [classRooms, setClassRooms] = useState([]);
  const [invitations, setInvitations] = useState([])
  const [selectedLanguages, setSelectedLanguages] = useState(AVAILABLE_LANGS);
  const [languageInputs, setLanguageInputs] = useState({})
  const history = useHistory();
  const location = useLocation();
  const { deckId } = useParams();
  const dispatch = useDispatch();
  const [checkedCards, setCheckedCards] = useState(false);
  const [publish, setPublish] = useState(false);
  const [ publishDate, setPublishDate] = useState(null);



  useEffect(() => {
    if (decks.editDeckValue && !isNew) {
      const editDeck = decks.editDeckValue;
      setTitle(editDeck.title);
      setPublishDate(editDeck.publishedDate);
      setAvailable(editDeck.available);
      setLevel(editDeck.level);
      setSelectedCards(editDeck.cards.map((cValue) => parseSearchCardTags(cValue)));
      setClassRooms(editDeck.classRooms ? editDeck.classRooms.map((cValue) => parseSearchClassesTags(cValue)) : []);
      setSelectedLanguages(editDeck.translations.filter((trans) => trans.active).map((trans) => trans.lang));
      setPremiumActive(editDeck.premium.active)
      setPremiumPrice(editDeck.premium.cost)
      setInvitations(editDeck.invitations)
      setAvatarUrl(
        editDeck.avatar?.mediumUrl ||
        editDeck.avatar?.miniUrl ||
        editDeck.avatar?.normalUrl ||
        editDeck.avatarUrl ||
        ''
      )
      setCategory(editDeck.category?._id || editDeck.category)
      setSubCategory(editDeck?.subCategory?._id || editDeck?.subCategory)
      setPublish(editDeck.isNew);

      let languageInputs_ = {};
      editDeck.translations.forEach((trans) => {
        languageInputs_[trans.lang] = trans.trans
      })
      setLanguageInputs(languageInputs_)
    }
  }, [decks.editDeckValue]);

  useEffect(() => {
    if(isNew){
      setTitle('');
      setAvailable(false);
      setLevel('Newbie');
      setSelectedCards([]);
      setClassRooms([]);
      setSelectedLanguages([]);
      setPremiumActive(false)
      setPremiumPrice('')
      setInvitations([])
      setAvatarUrl("")
      setLanguageInputs({})
    }
  }, [isNew]);

  // Preselect category/subcategory when navigating from Catalog (Add deck from subcategory)
  useEffect(() => {
    const state = location?.state;
    if (isNew && state?.fromCatalog && state?.categoryId && state?.subcategoryId) {
      setCategory(state.categoryId);
      setSubCategory(state.subcategoryId);
      history.replace(location.pathname, {}); // Clear state to avoid re-applying on remount
    }
  }, [isNew, location?.state, location?.pathname, history]);


  useEffect(() => {
    if (deckId ) {
      dispatch(fetchEditDeck({ _id: deckId }));
    }
  }, [deckId]);

  console.log("AVAILABLE_LANGS", AVAILABLE_LANGS)

  const handleSave = async () => {
    const postData = {
      title,
      translations: AVAILABLE_LANGS.map((lang) => ({
        lang,
        trans: languageInputs?.[lang] || '',
        active: selectedLanguages.includes(lang),
      })),
      avatarUrl,
      classRooms: classRooms.map((classe) => classe.value), //Ids de las clases
      invitations, //Emails de los usuarios para invitiar
      cards: selectedCards.map((card) => card.value), //Ids de las cards
      available,
      new: true,
      category,
      subCategory,
      active: available,
      premium: {
        active: premiumActive,
        cost: premiumPrice,
      },
      level,
      isNew:publish
    };
    if (deckId) {
      postData._id = deckId;
      await dispatch(fetchUpdateDeck(postData));
      setTimeout(() => {
        dispatch(fetchEditDeck({ _id: deckId }));
      }, 500);
    } else {
      const createResponse = await dispatch(fetchCreateDeck(postData));
      console.log("createResponse", createResponse);
      if (createResponse?.payload?._id) {
        const newDeck = createResponse.payload;
        if (category && subCategory) {
          const { categoryTitle, subcategoryTitle } = getCategoryTitles(category?.value ?? [], category, subCategory);
          dispatch(addCatalogItem({
            item: newDeck,
            categoryId: category,
            subcategoryId: subCategory,
            type: 'deck',
            categoryTitle,
            subcategoryTitle,
          }));
        }
        handleUploadFile(file, newDeck._id);
        setTimeout(() => {
          history.push(`/deck/edit/${newDeck._id}`);
        }, 1000);
      }
    }
  };

  const handleUploadFile = (file, deckId) =>{
    let body = new FormData();
    body.append('file', file)
    body.append('deckId', deckId)
    dispatch(fetchUpdateDeckAvatar(body))
  }

  const handleSetFile = (e) =>{
    setFile(e?.target.files[0])

    setFileURL(URL.createObjectURL(e?.target.files[0]))

    if(!isNew){
      handleUploadFile(e?.target.files[0], deckId)
    }
  }

    const refreshCheckedContextCards = (newvalue) => {
        if (deckId) {
          console.log("_____------>",newvalue);
            dispatch(fetchEditDeck({ _id: deckId,notChequedContext:newvalue }));
        }
    };

  const handleCheckedCardsChange = (newValue) => {

    console.log("the new value is -->",newValue);
    setCheckedCards(newValue);
    // Refrescar datos después de cambiar el toggle
    refreshCheckedContextCards(newValue);
  };

  return (
    <>
      <div className={styles.row}>
        <div className={styles.col}>


            <NameAndDescription
              className={styles.card}
              title={title}
              setTitle={setTitle}
              available={available}
              setAvailable={setAvailable}
              level={level}
              user={user}
              setLevel={setLevel}
              descriptionState={descriptionState}
              setDescriptionState={setDescriptionState}
              description={description}
              setDescription={setDescription}
              categorySelected={category}
              setCategory={setCategory}
              subCategory={subCategory}
              setSubCategory={setSubCategory}
              setPublish={setPublish}
              publishDate={publishDate}
              publish={publish}

          />

          <IncludedCards
              checkedCards={checkedCards}
              onCheckedCardsChange={handleCheckedCardsChange}
              deckId={deckId} className={styles.card} selectedCards={selectedCards} setSelectedCards={setSelectedCards} />
          <IncludedClasses className={styles.card} classRooms={classRooms} setClassRooms={setClassRooms} />
          <Invitations className={styles.card} invitations={invitations} setInvitations={setInvitations} />
          <CategoryAndAttibutes
            className={styles.card}
            selectedLanguages={selectedLanguages}
            setSelectedLanguages={setSelectedLanguages}
            languageInputs={languageInputs}
            setLanguageInputs={setLanguageInputs}
          />
          <ImagesAndCTA className={styles.card} handleUploadFile={handleSetFile} />
          <Price
            className={styles.card}
            premiumActive={premiumActive}
            setPremiumActive={setPremiumActive}
            premiumPrice={premiumPrice}
            setPremiumPrice={setPremiumPrice}
          />
          {/* <CategoryAndAttibutes className={styles.card} /> */}
          {/* <ProductFiles className={styles.card} />
          <Discussion className={styles.card} /> */}
        </div>
        <div className={styles.col}>
          <Preview visible={visiblePreview} onClose={() => setVisiblePreview(false)} avatarUrl={avatarUrl} title={title} file={fileURL} />
        </div>
      </div>
      <div className={cn("button", styles.button)} onClick={handleSave} >
        {decks.isLoadingCreate ? <Loader className={styles.loader} /> : <span>Save changes</span>}
      </div>

      {/* <Panel setVisiblePreview={setVisiblePreview} setVisibleSchedule={setVisibleModal} /> */}
      {/* <TooltipGlodal />
      <Modal visible={visibleModal} onClose={() => setVisibleModal(false)}>
        <Schedule startDate={startDate} setStartDate={setStartDate} startTime={startTime} setStartTime={setStartTime} />
      </Modal> */}
    </>
  );
};

export default NewDeck;
